import Api from '../../api'
import axios from '@/js/api'
import router from '../../router'
import breadcrumb from './breadcrumb.js'
// import {Message}from 'element-ui'
//let date = new Date();
//""+date.getFullYear()+(date.getMonth() + 1)+date.getDate()
const state = {
    previewFrom: {
        UniqueId: "",
        Name: "",
        Type: '',
        Category: 0,
        TypeValue: '',
        QCPlanGuid: "",
        HospitalIDList: [],
        AreaList: [],
        ExpertGroupIDList: [],
        ModalityTypes: [],
        DistributionRate: "",//分配比例
        StartDate: "",
        EndDate: "",
        PlannedCompleteDt: "",
        ParentSamplingTaskGuid: "",
        DiseaseType: "",
        AIcompanyIDList: [],
        IsPositive: '',
        ScanType: '',
        BodyPart: '',
        QCTimes: 1,
        hospitalGrade: 0,
        SubjectType: 2,
        samplingdoctor: 2
    },
    detailsRulesParameter: breadcrumb.state.detailsRulesParameter,
    AICompanys: [],
    DiseaseTypes: [],
    Hospitals: [],
    HospitalsSelset: {
        Hospitals: []
    },
    GetListArr: {

        mode: 0,
        enable: 1,
        startDate: '',
        endDate: '',
        pageIndex: 1,
        pageCount: 999,
        name: '',

        ScoreItemType: 0,
    },
    GetExpertGroupListArr: {
        status: 1,
        name: '',
        startDate: '',
        endDate: '',
        pageIndex: 1,
        pageCount: 999,
    },

    listReport: [],
    ExpertGroupList: [],
    previewData: {
        Hospitals: [],
        Doctors: [],
    },
    loading: false,
    rightLoading: false
};
const getters = {

};
const mutations = {
    setRightLoading(state, type) {
        // console.log(type);
        state.rightLoading = type
    },
    setReportScanType(state, res) {
        state.detailsRulesParameter.ScanType = res.data.Data;
        state.detailsRulesParameter.ScanType.forEach(item => {
            item.text = item.Name;
        })
    },
    setReportModality(state, res) {
        state.detailsRulesParameter.modalityType = res.data.Data;
        state.detailsRulesParameter.modalityType.forEach(item => {
            item.text = item.Name;
        })
    },
    setBodyParts(state, res) {
        state.detailsRulesParameter.BodyPart = res.data.Data;
        state.detailsRulesParameter.BodyPart.forEach(item => {
            item.text = item.Name;
        })
    },
    //loading
    setLoading(state, arr) {
        state.loading = arr;
    },
    //清空选择
    setPreviewFrom(state) {
        state.loading = false;
        state.previewFrom.UniqueId = "";
        state.previewFrom.Name = "";
        state.previewFrom.Type = '';
        state.previewFrom.Category = '';
        state.previewFrom.TypeValue = '';
        state.previewFrom.QCPlanGuid = "";
        state.previewFrom.HospitalIDList = [];
        state.previewFrom.AreaList = [];
        state.previewFrom.ExpertGroupIDList = [];
        state.previewFrom.ModalityTypes = [];
        state.previewFrom.DistributionRate = "";//分配比例
        state.previewFrom.StartDate = "";
        state.previewFrom.EndDate = "";
        state.previewFrom.PlannedCompleteDt = "";
        state.previewFrom.ParentSamplingTaskGuid = "";
        state.previewFrom.DiseaseType = "";
        state.previewFrom.AIcompanyIDList = [];
        state.previewFrom.IsPositive = '';
        state.previewFrom.ScanType = '';
        state.previewFrom.BodyPart = '';
        state.detailsRulesParameter.ScanTypes = [];
        state.detailsRulesParameter.BodyParts = [];
        state.detailsRulesParameter.IsPositives = [];
        state.previewData.Hospitals = [];
        state.previewData.Doctors = [];
        state.previewFrom.QCTimes = 1;
        state.previewFrom.hospitalGrade = 0;
    },
    //ai诊断公司
    SetAICompanys(state, arr) {
        state.AICompanys = arr.data;

    },
    SetDiseaseTypes(state, arr) {
        state.DiseaseTypes = arr.data
    },
    SetList(state, arr) {
        state.listReport = arr.data.QCPlans
    },
    SetExpertGroupList(state, arr) {
        state.ExpertGroupList = arr.data.ExpertGroupList
    }

};
const actions = {
    //扫描类型
    GetReportScanType({
        state,
        commit,
        dispatch
    }, arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportScanType).then(res => {
            commit('setReportScanType', res);
        })
    },
    //设备类型
    GetReportModality({
        state,
        commit,
        dispatch
    }, arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportModality).then(res => {
            commit('setReportModality', res);
        })
    },
    //获取检查部位
    GetBodyParts({
        state,
        commit,
        dispatch
    }, arr) {
        axios.ajaxGet('get', Api.api.manager.GetBodyParts).then(res => {
            commit('setBodyParts', res);
        })
    },
    //根据id获取检查部位
    GetBodyPartsByModality({
        state,
        commit,
        dispatch
    }, arr) {
        axios.ajaxGet('get', Api.api.manager.GetBodyPartsByModality, arr).then(res => {
            commit('setBodyParts', res);
            commit('setRightLoading', false)
        })
    },
    // 根据设备Id和部位Id获取扫描类型
    GetScanTypeByBodyId({
        state,
        commit,
        dispatch
    }, arr) {
        axios.ajaxGet('get', Api.api.manager.GetScanTypeByBodyId, arr).then(res => {
            commit('setReportScanType', res);
            commit('setRightLoading', false)
        })
    },
    //ai诊断公司
    GetAICompanys({ commit, state }) {
        axios.ajaxGet('get', Api.api.newTask.GetAICompanys).then(res => {
            commit('SetAICompanys', res)

        })
    },
    //诊断病种
    GetDiseaseTypes({ commit, state }) {

        axios.ajaxGet('get', Api.api.newTask.GetDiseaseTypes).then(res => {
            commit('SetDiseaseTypes', res)
        })
    },
    //获取方案列表
    GetList({ commit, state }) {
        state.GetListArr.type = state.previewFrom.Category;
        let modalityType = []

        let modalityTypeFilter = state.detailsRulesParameter.modalityTypeFilter.filter((res) => {

            for (let i = 0; i < state.previewFrom.ModalityTypes.length; i++) {
                if (res.text == state.previewFrom.ModalityTypes[i]) {
                    return res
                }
            }

        })
        modalityTypeFilter.map(res => {
            modalityType.push(res.text)
        })

        state.GetListArr.modalityType = modalityType.join(',');
        axios.ajaxGet('get', Api.api.newTask.GetList, state.GetListArr).then(res => {
            commit('SetList', res)
        })
    },
    //专家
    GetExpertGroupList({ commit, state }) {
        state.GetExpertGroupListArr.type = state.previewFrom.Category
        axios.ajaxGet('get', Api.api.newTask.GetExpertGroupList, state.GetExpertGroupListArr).then(res => {
            commit('SetExpertGroupList', res)
        })
    },
    //   //保存
    //   createorupdate({context,commit,state,dispatch}){

    //       let modalityType=[]

    //       let modalityTypeFilter=state.detailsRulesParameter.modalityTypeFilter.filter((res)=>{

    //        for(let i=0;i<state.previewFrom.ModalityTypes.length;i++){
    //            if(res.text==state.previewFrom.ModalityTypes[i]){
    //                return res
    //            }
    //        }       

    //       })
    //       modalityTypeFilter.map(res=>{
    //          modalityType.push(res.text)
    //       })      
    //       state.previewFrom.ModalityTypes=modalityType;

    //       state.previewFrom.ScanType= state.detailsRulesParameter.ScanTypes.join(',');
    //       state.previewFrom.BodyPart= state.detailsRulesParameter.BodyParts.join(',');
    //       state.previewFrom.IsPositive= state.detailsRulesParameter.IsPositives.join(',');
    //         axios.ajaxPost('post',Api.api.newTask.createorupdate,state.previewFrom).then(res=>{
    //           router.push('/home/manager/task/taskall')
    //           dispatch('setPreviewFrom')
    //           ELEMENT.Message.success(res.data.Msg);
    // 	commit('managerPlanList/currentChanges', 1, {root: true})
    //         })
    //   }





}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
